<template>
  <v-card outlined class="elevation-0">
    <v-card-title class="d-flex justify-space-between">
      <div>Danh sách Tài liệu</div>
      <v-btn outlined color="primary" class="elevation-0 my-1" @click="upload">
        <v-icon left>mdi-upload</v-icon>
        <span>Upload tệp</span>
        <input ref="uploader" type="file" class="d-none" accept=".pdf, .xlsx, .doc, .docx" @change="onFileChanged" />
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        no-data-text="Không có dữ liệu"
        :footer-props="{
          itemsPerPageText: 'Số dòng mỗi trang:',
          itemsPerPageAllText: 'Tất cả',
        }"
        :headers="headers"
        :items="items"
        disable-sort
        :loading="tableLoading"
        height="400"
      >
        <template v-slot:[`item.title`]="{ item }">
          <div @click="item.data ? showFile(item.data) : null" style="color: #1a0dab; cursor: pointer">
            {{ item.data.title }}
          </div>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.createdAt | ddmmyyyy }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="showFile(item.file)">
                <v-list-item-title>Xem tài liệu</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteDocument(item)">
                <v-list-item-title>Xóa</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
      <TeacherOfficeViewer :state="dialogState" :file="selectedFile" @close-dialog="dialogState = false" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import TeacherOfficeViewer from '../office-viewer/TeacherOfficeViewer.vue'

export default {
  components: {
    TeacherOfficeViewer,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      headers: [
        { text: 'STT', value: 'index' },
        { text: 'Tên tài liệu', value: 'title' },
        { text: 'Ngày tạo', value: 'createdAt' },
        { text: 'Người tạo', value: 'createdByName' },
        { text: 'Thao tác', value: 'actions', align: 'center' },
      ],
      dialogState: false,
      selectedFile: null,
      tableLoading: false,
      isSelecting: false,
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      statusMappings: {
        'not seen': 'Chưa duyệt',
        approved: 'Đã duyệt',
        denied: 'Từ chối duyệt',
      },
    }
  },
  computed: {
    ...mapState({
      profile(state) {
        return state['auth'].profile
      },
      role(state) {
        return state['auth'].role
      },
      user(state) {
        return state['auth'].user
      },
      items(state) {
        return state['gradeDocument'].documents.map((v, index) => ({ index: index + 1, ...v }))
      },
    }),
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    ...mapActions('upload', ['uploadFile']),
    ...mapActions('gradeDocument', ['createDocument', 'removeDocument']),
    upload() {
      this.$refs.uploader.value = ''
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      const file = e.target.files[0]

      try {
        let formData = new FormData()
        formData.append('files', file)
        formData.append('ref', 'teacher-document')
        formData.append('field', 'file')
        const response = await this.uploadFile(formData)
        const uploadedFile = response[0]
        const updatedData = {
          title: uploadedFile.name,
          url: uploadedFile.url,
        }

        await this.createDocument({
          grade: this.item.grade,
          docCategory: this.item._id,
          data: { ...updatedData },
        })
        this.$emit('refresh', this.item)
        this.$alert.success('Tải file thành công')
      } catch (error) {
        this.$alert.error('Tải file thất bại, vui lòng thử lại. Lỗi: ' + error)
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    closeDialog() {
      this.$emit('input', false)
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      return moment(dateStr).format('DD/MM/YYYY')
    },
    showFile(file) {
      this.selectedFile = file
      this.dialogState = !this.dialogState
    },
    async deleteDocument(item) {
      this.tableLoading = true
      try {
        await this.removeDocument(item.id)
        this.$emit('refresh', this.item)
        this.$alert.success('Tài liệu đã được xóa')
      } catch (error) {
        this.$alert.error('Lỗi xóa tài liệu: ' + error)
      } finally {
        this.tableLoading = false
      }
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    setTableLoading(status) {
      this.tableLoading = status
    },
  },
}
</script>
